import {
	captureSponsorLead,
	exchangeSponsorScannerToken,
	getSponsorScannerContext,
} from '~/api/provider';
import {
	getSelectedRepresentative,
	getSponsorAccessToken,
	setSelectedRepresentative,
} from '~/helpers/token-helpers';
import { AppDispatch } from '~/store';
import {
	bootstrapFailed,
	bootstrapStart,
	bootstrapSucceeded,
	captureFailed,
	captureStart,
	captureSucceeded,
	setSelectedRepresentative as setSelectedRepresentativeAction,
} from './sponsorScanSlice';

/**
 * Boot the sponsor-scan session: exchange the link token for a JWT if we don't have one
 * cached yet, then fetch the sponsor + reps context. Rehydrates the previously-picked
 * representative from sessionStorage so a refresh mid-session is invisible to the rep.
 */
export const bootstrapSponsorScan = (sponsorId: string, exchangeToken: string | null) => async (
	dispatch: AppDispatch,
) => {
	dispatch(bootstrapStart());

	if (!getSponsorAccessToken(sponsorId)) {
		if (!exchangeToken) {
			dispatch(bootstrapFailed('Scanner link is missing its token. Generate a fresh one from the sponsor portal.'));
			return;
		}
		const tokenResult = await exchangeSponsorScannerToken(sponsorId, exchangeToken);
		if (!tokenResult.ok) {
			dispatch(bootstrapFailed(tokenResult.errorMessage));
			return;
		}
	}

	const ctx = await getSponsorScannerContext(sponsorId);
	if (!ctx.ok) {
		dispatch(bootstrapFailed(ctx.errorMessage));
		return;
	}

	dispatch(bootstrapSucceeded(ctx.data));

	const previouslySelected = getSelectedRepresentative(sponsorId);
	if (previouslySelected && ctx.data.representatives?.some((r: { id: string }) => r.id === previouslySelected)) {
		dispatch(setSelectedRepresentativeAction(previouslySelected));
	}
};

export const selectRepresentative = (sponsorId: string, representativeId: string | null) => (
	dispatch: AppDispatch,
) => {
	setSelectedRepresentative(sponsorId, representativeId);
	dispatch(setSelectedRepresentativeAction(representativeId));
};

export const captureLead = (sponsorId: string, barcode: string, representativeId: string) => async (
	dispatch: AppDispatch,
) => {
	dispatch(captureStart());
	const result = await captureSponsorLead(sponsorId, barcode, representativeId);
	if (!result.ok) {
		dispatch(captureFailed(result.errorMessage));
		return;
	}
	dispatch(
		captureSucceeded({
			lead: result.data.lead,
			deduped: result.data.deduped === true,
		}),
	);
};
